import { Pipe, PipeTransform } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'treeDeviceTootip',
  pure: false
})
export class TreeDeviceTootipPipe implements PipeTransform {

  constructor (
    private translate: TranslateService
  ) {

  }

  transform(node: TreeNode): unknown {
    return   `<strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_ZABBIX_HOST')} </strong>: <span class='pl-5 float-right'>${node.data.device?.hostname || ''  } </span>
              <strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_IP_ADDRESS' )} </strong>: <span class='pl-5 float-right'>${node.data.device?.ipAddr || '' } </span>
              <strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_SERIAL' )}  </strong>: <span class='pl-5 float-right'>${node.data.device?.serial || '' } </span>
              <strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_CONFIG' )}  </strong>: <span class='pl-5 float-right'>${node.data.device?.config || '' }  </span>
              <strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_FIRMWARE')} </strong>: <span class='pl-5 float-right'>${node.data.device?.firmware || '' } </span>
              <strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_TYPE' )}  </strong>:  <span class='pl-5 float-right'>${node.data.device?.type || '' }  </span>
              <strong>  ${this.translate.instant('I18N_MONITORING.PAINTED_CAR_NUMBER' )}  </strong>: <span class='pl-5 float-right'>${node.data.device?.paintedCoachId || '' }  </span>
              <strong>  ${this.translate.instant('I18N_MONITORING.DEVICE_POSITION' )}  </strong>: <span class='pl-5 float-right'>${node.data.device?.position || '' }  </span>`
  }
  
}
